<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="uZrYOkXuhPJLTlJlWhC5Bh7">
<p class="perfect-center"><span class="bold1"><br class="calibre3"/></span></p>
<p class="perfect-center"><span class="bold1">To the paratroopers of First Platoon, Charlie Troop, of the 4</span><span class="bold2">th</span><span class="bold1"> Squadron/73</span><span class="bold2">rd</span><span class="bold1"> Cavalry Regiment, 4</span><span class="bold2">th</span><span class="bold1"> Brigade Combat Team, </span></p>
<p class="perfect-center"><span class="bold1">82</span><span class="bold2">nd</span><span class="bold1"> Airborne Division, United States Army</span></p>
<p class="perfect-center"><span class="bold1">for their Gallant Service in Afghanistan – 2012</span></p>
<p class="perfect-center"><span class="bold1"><br class="calibre3"/></span></p>
<p class="perfect-center"><span class="bold1">“All the Way!”</span></p>
<p class="perfect-center"><br class="calibre3"/></p>
<p class="perfect-center"><span class="bold1">In memory of:</span></p>
<p class="perfect-center"><span class="bold1">PFC MARK L KERNER, 82</span><span class="bold2">nd</span><span class="bold1"> Airborne Division</span></p>
<p class="perfect-center"><span class="bold1">November 19, 1991 ~ March 1, 2015 (age 23)</span></p>
<p class="perfect-center"><span class="bold1">&amp;</span></p>
<p class="perfect-center"><span class="bold1">CPL MATTHEW HANES, 82ND Airborne Division</span></p>
<p class="perfect-center"><span class="bold1">June 27, 1991 ~ August 7, 2015 (age 24)</span></p>
<p class="perfect-center"><span class="bold1"><br class="calibre3"/></span></p>
<p class="perfect-center"><span class="bold1"><br class="calibre3"/></span></p>
<p class="perfect-center"><span class="bold1">A Special Salute to:</span></p>
<p class="perfect-center"><span class="bold1">1LT Don Latino and PFC Samuel Walley</span></p>
<p class="perfect-center"><span class="bold1">Both Awarded the Purple Heart</span></p>
<p class="perfect-center"><span class="bold1"><br class="calibre3"/></span></p>
<p class="perfect-center"><span class="bold1">With Special Gratitude to </span></p>
<p class="perfect-center"><span class="bold1">THE UNITED AMERICAN PATRIOTS</span></p>
<p class="perfect-center"><br class="calibre3"/></p>
<p class="perfect-center">For supporting</p>
<p class="perfect-center">Our nation’s warriors</p>
<p class="perfect-center">falsely accused of “war crimes.”</p>
<p class="perfect-center">To help American soldiers like Clint Lorance,</p>
<p class="perfect-center">go to<br class="calibre3"/></p>
<p class="perfect-center"><br class="calibre3"/></p>
<p class="perfect-center"><a href="http://WWW.UAP.ORG" target="_blank">WWW.UAP.ORG</a><br class="calibre3"/></p>
<p class="perfect-center"><br class="calibre3"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?23d5eb2a